import { recordPath, recordRoute } from '@/shared/registry'

/** Where the content library pages live. */
export const contentLibrariesPath = '/catalog/content-libraries'
export const createContentLibraryPath = `${contentLibrariesPath}/new`
export const contentLibraryRoute = recordRoute('catalog', 'content-libraries')
export const editContentLibraryRoute = `${contentLibraryRoute}/edit`

/** A content library's details page. */
export function contentLibraryPath(id: string): string {
  return recordPath('catalog', 'content-libraries', id)
}

/** The base of Content Library Details' slots (`detailsSlots`). */
export const contentLibraryDetailsSlot = 'catalog.content-library-details'

/** The API's content library endpoints. */
export const contentLibrariesApi = '/catalog/v1/content-libraries'

export function contentLibraryApi(id: string): string {
  return `${contentLibrariesApi}/${encodeURIComponent(id)}`
}

/** Where a library's courses are set, all at once. */
export function contentLibraryCoursesApi(id: string): string {
  return `${contentLibraryApi(id)}/courses`
}

/** What each content library action needs. */
export const readContentLibrariesPermission = 'catalog.content-libraries.read'
export const writeContentLibrariesPermission = 'catalog.content-libraries.write'
export const deleteContentLibrariesPermission = 'catalog.content-libraries.delete'
